import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Converts markdown-style formatting to React elements
 * *text* -> italic
 * **text** -> bold
 */
export function formatMarkdown(text) {
  if (!text) return text;
  
  const textStr = String(text);
  const elements = [];
  let keyCounter = 0;
  
  // First, replace all **bold** with a placeholder
  const boldPlaceholders = [];
  let boldIndex = 0;
  
  // Replace **text** with placeholders (non-greedy to handle multiple bold sections)
  let processedText = textStr.replace(/\*\*([^*]+?)\*\*/g, (match, content) => {
    const placeholder = `__BOLD_${boldIndex}__`;
    boldPlaceholders.push({ placeholder, content });
    boldIndex++;
    return placeholder;
  });
  
  // Now split by italic patterns and process
  const parts = processedText.split(/(\*[^*]+\*)/g);
  
  parts.forEach((part) => {
    if (!part) return; // Skip empty parts
    
    // Check if this part contains bold placeholders
    if (part.includes('__BOLD_')) {
      // Split by bold placeholders and process each segment
      const boldParts = part.split(/(__BOLD_\d+__)/g);
      boldParts.forEach((boldPart) => {
        if (!boldPart) return;
        const boldMatch = boldPart.match(/^__BOLD_(\d+)__$/);
        if (boldMatch) {
          const placeholderIndex = parseInt(boldMatch[1]);
          const boldData = boldPlaceholders[placeholderIndex];
          if (boldData) {
            elements.push(<strong key={`bold-${keyCounter++}`}>{boldData.content}</strong>);
          }
        } else if (boldPart.startsWith('*') && boldPart.endsWith('*')) {
          // Italic
          const content = boldPart.slice(1, -1);
          elements.push(<em key={`italic-${keyCounter++}`}>{content}</em>);
        } else {
          // Regular text
          elements.push(boldPart);
        }
      });
    } else if (part.startsWith('*') && part.endsWith('*')) {
      // This is an italic match
      const content = part.slice(1, -1);
      elements.push(<em key={`italic-${keyCounter++}`}>{content}</em>);
    } else {
      // Regular text
      elements.push(part);
    }
  });
  
  return elements.length > 0 ? elements : text;
}
